<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.especialidade"
                    :request-query-string-params="{ not_id: especialidadesPrestadorasIds }"
                    :search-fields="fields.especialidade"
                    :validations="validations.especialidade"
                    label="Especialidade"
                    :text-field="e => `${e.codigo} - ${e.nome}`"
                    uppercase
                    v-model="model.especialidade"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                especialidade: { required: true },
            }
        },
        especialidadesPrestadorasIds() {

            return this.prestador.especialidades.map(e => e.id)
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            especialidade: [
                { key: 'ocupacao.codigo', searchable: true },
                { key: 'especialidade.nome', searchable: true },
            ],
        },
        model: {
            especialidade: null,
        }
    }),
    methods: {
        add() {

            this.prestador.especialidades.push(this.prepareData())

            this.resetForm()
        },
        prepareData() {

            const especialidade = this.clone(this.model.especialidade)

            especialidade.ativo = true

            return especialidade
        },
        resetForm() {

            this.model.especialidade = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [repository, object],
    props: {
        prestador: { type: Object, required: true },
    },
}
</script>